import {Box, Card, Stack, Typography} from '@mui/material';
import * as React from 'react';
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {formatHourDatePicker, formatLongDatePicker} from '../Service';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import {useUserInfo} from '../userInfo/hooks/useUserInfo';
import {useWeather} from '../weather/hooks/useWeather';
import {withWeatherContext} from '../weather/state/weatherContext';
import AvatarProfile from './AvatarProfile';
import ProfileButton from './buttons/ProfileButton';
import {useGodFather} from '../profile/hooks/useGodFather';

const Profil = () => {
  const {profil} = useUserInfo();
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const {weather} = useWeather();
  const navigate = useNavigate();
  const {mode} = useDarkMode();

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(formatHourDatePicker(new Date()));
      setDate(formatLongDatePicker(new Date()));
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const {initializeContacts} = useGodFather();
  const [loadingContacts, setLoadingContacts] = useState(false);

  const handleSynchContacts = async () => {
    setLoadingContacts(true);
    try {
      await initializeContacts();
    } finally {
      setLoadingContacts(false);
      window.location.replace(
        `${process.env.REACT_APP_NEXTCLOUD_BASE_URL}${process.env.REACT_APP_NEXTCLOUD_CONTACT_URL}`,
      );
    }
  };

  return (
    <Card
      class={'sideMenuCard'}
      style={{backgroundColor: mode.settings.cardBackgroundColor}}>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
        padding={1}
        sx={{minHeight: '354px'}}>
        <Stack
          direction="row"
          justifyContent="space-around"
          alignItems="center"
          width={'100%'}
          sx={{minHeight: '76px'}}>
          <Box sx={{minWidth: '109px'}}>
            <Stack direction="column">
              <Typography
                variant={'subtitle3'}
                color={mode.settings.textColor3}>
                {date}
              </Typography>
              <Typography
                variant={'subtitle3'}
                color={mode.settings.textColor3}>
                {time}
              </Typography>
            </Stack>
          </Box>
          {weather ? (
            <Stack alignItems="center" m={0} sx={{minWidth: '76.6px'}}>
              <img
                style={{width: '55px', height: '55px'}}
                alt={'Méteo du jour'}
                src={weather.icon}
                role="img"
              />
              <Typography
                color={mode.settings.textColor3}
                variant={'subtitle3'}
                style={{
                  display: 'flex',
                }}>
                {weather.temperature.toString().split('.')[0] === '-0'
                  ? '0'
                  : weather.temperature.toString().split('.')[0]}{' '}
                C°
              </Typography>
            </Stack>
          ) : (
            <Box sx={{minWidth: '76.6px'}}></Box>
          )}
        </Stack>
        {profil && <AvatarProfile size={69} showName={true} />}
        <Stack
          direction="row"
          justifyContent="left"
          alignItems="flex-start"
          spacing={1}>
          <ProfileButton
            text={'Mes contacts'}
            icon={`/assets/icon/contact.png`}
            loading={loadingContacts}
            onClick={handleSynchContacts}
          />
          <ProfileButton
            text={'Mes photos'}
            icon={`/assets/icon/photo.png`}
            link={`${process.env.REACT_APP_NEXTCLOUD_BASE_URL}${process.env.REACT_APP_NEXTCLOUD_PHOTO_URL}`}
          />
        </Stack>
        <Stack
          direction="row"
          justifyContent="left"
          alignItems="flex-start"
          spacing={1}>
          <ProfileButton
            text={'Mon agenda'}
            icon={`/assets/icon/agenda.png`}
            link={`${process.env.REACT_APP_NEXTCLOUD_BASE_URL}${process.env.REACT_APP_NEXTCLOUD_AGENDA_URL}`}
          />
          <ProfileButton
            text={'Mes documents'}
            icon={`/assets/icon/document.png`}
            link={`${process.env.REACT_APP_NEXTCLOUD_BASE_URL}${process.env.REACT_APP_NEXTCLOUD_DOCUMENT_URL}`}
          />
        </Stack>
        <Stack
          direction="row"
          justifyContent="left"
          alignItems="flex-start"
          spacing={1}>
          <button
            className={'profileButton'}
            onClick={() => navigate('/order-history')}
            style={{backgroundColor: mode.settings.inputBackgroundColor}}>
            <img
              src={`/assets/icon/shopping_cart.png`}
              alt={'Mes commandes'}
              style={{
                width: '29px',
                height: '31px',
                marginLeft: '-1px',
              }}
            />
            <Typography
              variant={'subtitle5'}
              sx={{marginLeft: '4px'}}
              color={mode.settings.textColor3}>
              Mes commandes
            </Typography>
          </button>
          <button
            className={'profileButton'}
            onClick={() => navigate('/game')}
            style={{backgroundColor: mode.settings.inputBackgroundColor}}>
            <img
              src={`/assets/icon/jeux-bleu.png`}
              alt={'Jeux'}
              style={{width: '30px', height: '30px'}}
            />
            <Typography
              variant={'subtitle5'}
              sx={{marginLeft: '4px'}}
              color={mode.settings.textColor3}>
              Jeux
            </Typography>
          </button>
        </Stack>
      </Stack>
    </Card>
  );
};

export default withWeatherContext(Profil);
